import { c as _c } from "react/compiler-runtime";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface NotificationTimestampProps {
  readonly createdAt: number;
  readonly className?: string | undefined;
}
export default function NotificationTimestamp(t0) {
  const $ = _c(6);
  const {
    createdAt,
    className: t1
  } = t0;
  const className = t1 === undefined ? "tw-text-sm" : t1;
  const t2 = `${className} tw-whitespace-nowrap tw-font-normal tw-text-iron-300`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-mr-1 tw-text-xs tw-font-bold tw-text-iron-400">•</span>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== createdAt) {
    t4 = getTimeAgoShort(createdAt);
    $[1] = createdAt;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}